export default {
	
}


// WEBPACK FOOTER //
// ./src/store/mp/marketing/coupon/getters.js